export default "__VITE_ASSET__CP37de12__"